export const NOTIFY = {
    LAUNCH_RENEWABLE_PROCESS: {
        SUCCESS:"Process start success"
    },
    ATTESTATION: {
        add:{
            SUCCESS:"Attestation created",
            ERROR:"Failed to create attestation"
        },
        edit:{
            SUCCESS:"Attestation updated",
            ERROR:"Failed to update attestation"
        }
    },
};
